<ng-container *ngIf="isBrowser">
    <ng-container *ngTemplateOutlet="homefilter"></ng-container>
</ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>


<ng-template #homemodeMobile>
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title">{{title}}</span>
        <div class="tmp-section-body">
            <button class="tmp-f-selection-btn"  #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin (click)="openModalMobile($event)" matRipple>
                <div class="tmp-btn-sub">
                    <mat-icon class="tmp-f-selection-btn-icon mr05">schedule</mat-icon>
                    <span>{{mySearchControl}}</span>
                </div>
                <mat-icon class="tmp-f-selection-btn-icon">arrow_drop_down</mat-icon>
            </button>
        </div>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="sendSelect()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #homefilterdesk>
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title">{{title}}</span>
        <div class="tmp-section-body">
            <button class="tmp-f-selection-btn"  #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin (click)="openModal($event)" matRipple>
                <div class="tmp-btn-sub">
                    <mat-icon class="tmp-f-selection-btn-icon mr05">schedule</mat-icon>
                    <span>{{mySearchControl}}</span>
                </div>
                <mat-icon class="tmp-f-selection-btn-icon">arrow_drop_down</mat-icon>
            </button>
        </div>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="sendSelect()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>


<ng-template #modal>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mobileDesk"></ng-container>
    </ng-container>
</ng-template>


<ng-template #mobileDesk>
    <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <div class="f-headerwrapper">
                <input type="text" placeholder="Flughafen hinzufügen" [(ngModel)]="mySearchControl" ng-focus
                    [appAutoFocus]="focus" class="searchinput">
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <button matRipple (click)="sendSelect()">
                    <mat-icon class="btnico-mobile">arrow_back</mat-icon>
                </button>
                <input type="text" placeholder="Flughafen hinzufügen" [(ngModel)]="mySearchControl" ng-focus
                    [appAutoFocus]="focus" class="searchinput">
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="f-bodywrapper" [class.f-bodywrapper-mobile]="media === 'xs' || media=== 'sm'">
        <div class="f-info-wrapper">
            <span class="f-title">Mögliche Eingebeformate</span>
            <div class="zeitblock">
                <span>8-11</span>
                <span>Zeit zw. 8Uhr und 11Uhr</span>
            </div>
            <div class="zeitblock">
                <span>16+</span>
                <span>Zeit nach 16Uhr</span>
            </div>
            <div class="zeitblock">
                <span>-12</span>
                <span>Zeit vor 12Uhr</span>
            </div>
            <div class="zeitblock">
                <span>12:00</span>
                <span>Zeit um 12Uhr</span>
            </div>
        </div>
    </div>
    <div class="ubwrapper">
        <button class="ubbtn" (click)="sendSelect()">ÜBERNEHMEN</button>
    </div>
</ng-template>